import { createContext, type Dispatch, type SetStateAction } from "react"
import { type SelectItem } from "@/utils/dataTypes"

export interface ITokenListContext {
  filterKeyword: string
  setFilterKeyword: Dispatch<SetStateAction<string>>
  selectedToken: SelectItem | undefined
  tokens: SelectItem[]
  nickName: string
  handleClose: () => void
  handleTokenSelect: (token: SelectItem) => void
  hasMoreTokens: boolean
  loadMoreTokens: (uptoIndex?: number) => Promise<void>
  isInitialLoading: boolean
  isDisplayAddress: boolean
  isShowDialog: boolean
  availableRecentTokens: SelectItem[]
}

const TokenListContextDefaultValue: ITokenListContext = {
  filterKeyword: "",
  setFilterKeyword: () => null,
  selectedToken: undefined,
  tokens: [],
  nickName: "",
  handleClose: () => null,
  handleTokenSelect: () => null,
  hasMoreTokens: false,
  loadMoreTokens: () => Promise.resolve(),
  isInitialLoading: false,
  isDisplayAddress: false,
  isShowDialog: false,
  availableRecentTokens: [],
}

const TokenListContext = createContext(TokenListContextDefaultValue)
export default TokenListContext
